import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy standalone Active Work page — folded into the Operations
 * Workspace as a collapsible panel. Redirect preserves old bookmarks.
 */
export const Route = createFileRoute("/_authenticated/app/operations/active-work")({
  beforeLoad: () => {
    throw redirect({ to: "/app/operations/desk", replace: true });
  },
});